import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';

import CalculatorCard from 'hcla-web-frontend-primitives/app/components/primitives/Card/CalculatorCard';
import { calcTempBasedFIT, calcReliabilityFromFIT } from './calcTempBasedFIT';

const styles = () => ({
  content: {
    flex: '1 0 auto',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
  },
});

class ThermalReliabilityCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fit: {
        failureRate: NaN,
        AF: NaN,
        FIT: NaN,
        MTTF: NaN,
      },
      reliability: {
        thermalReliability: NaN,
      },
    };
    this.updateComputation = this.updateComputation.bind(this);
  }

  updateComputation = (e) => {
    const { data } = this.props;
    this.setState({
      fit: calcTempBasedFIT(
        Number(e.target.value),
        data.testTemp,
        data.actEnergy,
        data.testDuration,
        data.numFailures,
        data.sampleSize,
        data.confidence,
      ),
    });
  };

  calculateReliability = (e) => {
    this.setState({
      reliability: calcReliabilityFromFIT(
        this.state.fit.FIT,
        Number(e.target.value),
      ),
    });
  };

  render() {
    const { classes, data } = this.props;
    const { fit, reliability } = this.state;
    return (
      <CalculatorCard>
        <CardHeader title="Reliability Calculator" subheader={data.partId} />
        <Divider />
        <CardContent className={classes.content}>
          <TextField
            value={Number(fit.FIT).toFixed(2)}
            InputLabelProps={{
              shrink: true,
              readOnly: true,
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">FIT</InputAdornment>,
            }}
            helperText="Thermal Adjusted FIT"
            fullWidth
            margin="normal"
          />
          <TextField
            value={Number(fit.MTTF).toExponential(3)}
            InputLabelProps={{
              shrink: true,
              readOnly: true,
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">hrs</InputAdornment>,
            }}
            helperText="MTTF"
            fullWidth
            margin="normal"
          />
          <TextField
            value={Number(reliability.thermalReliability).toFixed(4)}
            InputLabelProps={{
              shrink: true,
              readOnly: true,
            }}
            helperText="Thermal Reliability"
            fullWidth
            margin="normal"
          />
        </CardContent>
        <Divider />
        <CardActions
          classes={{
            root: classes.actions,
          }}
        >
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">˚C</InputAdornment>,
            }}
            placeholder="Application Temp."
            helperText="Input application temperature here"
            fullWidth
            autoComplete={false}
            onChange={(e) => { this.updateComputation(e); this.calculateReliability(e); }}
            margin="normal"
            type="number"
          />
          <TextField
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">hrs</InputAdornment>,
            }}
            placeholder="Mission Time"
            helperText="Input mission time here"
            fullWidth
            autoComplete={false}
            onChange={e => this.calculateReliability(e)}
            margin="normal"
            type="number"
          />
        </CardActions>
      </CalculatorCard>
    );
  }
}

ThermalReliabilityCard.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({
    partId: PropTypes.string.isRequired,
    useTemp: PropTypes.number.isRequired,
    testTemp: PropTypes.number.isRequired,
    actEnergy: PropTypes.number.isRequired,
    testDuration: PropTypes.number.isRequired,
    numFailures: PropTypes.number.isRequired,
    sampleSize: PropTypes.number.isRequired,
    confidence: PropTypes.number.isRequired,
  }).isRequired,
};

export default withStyles(styles, { withTheme: true })(ThermalReliabilityCard);
